import angular from 'angular'
import 'angular-animate-model-change/src/index.js'

import ggsUtils from '../utils'
import ggsLocale from '../ggs-locale'
import ggsTimeago from '../ggs-timeago'
import ggsImgQueue from '../ggs-img-queue'

import ggsGallery from '../gallery'
import ggsGalleryRpc from '../gallery-rpc'
import ggsGalleryOverlay from '../gallery-overlay'
import ggsGalleryProperties from '../gallery-properties'

const ngAnimateChange = 'dm.animateModelChange'

angular
  .module('ggs', [
    ngAnimateChange,
    ggsUtils,
    ggsLocale,
    ggsTimeago,
    ggsImgQueue,
    ggsGallery,
    ggsGalleryRpc,
    ggsGalleryOverlay,
    ggsGalleryProperties
  ])
